import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

// GET all billOfMaterialses
export const getBillOfMaterials = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/bill-of-materials`);
    return response.data;
  } catch (error) {
    console.error("Error fetching bill-of-materials:", error.response?.data || error);
    throw error;
  }
};

// GET a single billOfMaterials
export const getBillOfMaterialsById = async (id) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/bill-of-materials/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching bill-of-materials:", error.response?.data || error);
    throw error;
  }
};

// CREATE a new billOfMaterials
export const createBillOfMaterials = async (billOfMaterialsData) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/bill-of-materials`, billOfMaterialsData);
    return response.data;
  } catch (error) {
    console.error("Error creating bill-of-materials:", error.response?.data || error);
    throw error;
  }
};

// UPDATE an existing billOfMaterials
export const updateBillOfMaterials = async (id, billOfMaterialsData) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/bill-of-materials/${id}`, billOfMaterialsData);
    return response.data;
  } catch (error) {
    console.error("Error updating bill-of-materials:", error.response?.data || error);
    throw error;
  }
};

// DELETE a billOfMaterials
export const deleteBillOfMaterials = async (id) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/bill-of-materials/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting bill-of-materials:", error.response?.data || error);
    throw error;
  }
};

// GET billOfMaterials by taskId
export const getBillOfMaterialsByTaskId = async (taskId) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/bill-of-materials`, {      params: { taskId },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching bill-of-materials:', error.response?.data || error);
    throw error;
  }
};
